<button [type]="buttonType" class="w-full py-[14px] px-[20px] btn-primary text-sm leading-none" (click)="click()" [disabled]="isDisable">
  <span class="loading-spinner" role="status">
    <span class="global-spinner-xs" *ngIf="isLoading"><span></span>
      <span class="accessibleHidden" >loading, please wait</span>
    </span>
  </span>
  <span>{{text}}</span>
</button>
